










import { Component, Vue } from "vue-property-decorator";
import VIconPrev from "../components/VIconPrev.vue";
import VIconNext from "../components/VIconNext.vue";

@Component({
  components: {
    VIconPrev,
    VIconNext
  }
})
export default class SalesReportDate extends Vue {}
